import { Directive } from '@angular/core';

@Directive({
  selector: 'xpo-empty-state-actions',
})
export class XpoEmptyStateActions {}
